/**
 * Web: no native MMKV — use localStorage with a key prefix based on an id.
 */
function createWebStorage(id: string) {
  const prefix = `${id}:`;
  const canUseStorage = () => typeof localStorage !== 'undefined';

  return {
    getString: (key: string): string | undefined => {
      if (!canUseStorage()) return undefined;
      try {
        return localStorage.getItem(prefix + key) ?? undefined;
      } catch {
        return undefined;
      }
    },
    set: (key: string, value: string): void => {
      if (!canUseStorage()) return;
      try {
        localStorage.setItem(prefix + key, value);
      } catch {
        /* quota */
      }
    },
    remove: (key: string): void => {
      if (!canUseStorage()) return;
      try {
        localStorage.removeItem(prefix + key);
      } catch {
        /* ignore */
      }
    },
  };
}

export const storage = createWebStorage('app-storage');
export const secureStorage = createWebStorage('secure-storage');
